<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body"
              default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ (this.data.add) ? "ADD NEW" : "UPDATE" }} ITEM</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <!-- Image Container -->
      <div class="img-container w-32 mx-auto flex items-center justify-center">
        <img :src="dataImg" alt="img" class="responsive">
      </div>
      <div class="upload-img mt-5 text-center">
        <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
        <vs-button @click="$refs.uploadImgInput.click()">Upload Image</vs-button>
        <vs-button type="flat" color="#999" @click="dataImg = null">Remove Image</vs-button>
      </div>
      <div class="p-6">
        <places v-if="user_property['Google-Places-ID'] === null" :found="placesFound" class="mt-5 w-full"></places>
        <div v-else>
          <span class="text-primary">{{user_property['Google-Places-ID']}}<u><span class="cursor-pointer ml-4 text-primary" @click="changePlace">change</span></u></span>
        </div>
        <vs-input ref="item-name"  name="item-name"  label="Owner Name" v-model="name" class="mt-5 w-full" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>

        <vs-input ref="item-last-name" label="Owner Last Name" v-model="last_name" class="mt-5 w-full"
                  name="item-last-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-last-name')">{{ errors.first('item-last-name') }}</span>

        <vs-input ref="item-email" label="E-mail" type="email" v-model="email" class="mt-5 w-full" name="item-email" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-email')">{{ errors.first('item-email') }}</span>

       <vs-input ref="item-phone" label="Phone" type="tel" v-model="phone" class="mt-5 w-full" name="item-phone" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-phone')">{{ errors.first('item-phone') }}</span>

        <vs-input
          ref="password"
          type="password"
          data-vv-validate-on="blur"
          v-validate="'required|min:6|max:10'"
          name="password"
          label="Password"
          v-if="data.add"
          placeholder="Password"
          v-model="password"
          class="w-full mt-6" />
        <span class="text-danger text-sm">{{ errors.first('password') }}</span>

        <vs-input
          type="password"
          ref="confirm-password"
          v-validate="'min:6|max:10|confirmed:password'"
          data-vv-validate-on="blur"
          data-vv-as="password"
          name="confirm-password"
          label="Confirm Password"
          v-if="data.add"
          placeholder="Confirm Password"
          v-model="confirm_password"
          class="w-full mt-6" />
        <span class="text-danger text-sm">{{ errors.first('confirm-password') }}</span>

        <div class="w-full mt-5" v-for="property of propertyList" :key="property.id" v-if="property.property_type === 'text' && !property.code.includes('Google')">

          <vs-input :label="property.name"
                    :ref="property.code"
                    :value="user_property[property.code]"
                    @input="onDataChange(property.code, $event)"
                    class="w-full mt-6"
                    :name="property.code"
                    v-validate="isFieldRequired(property)" />
          <span class="text-danger text-sm" v-show="errors.has(property.code)">{{ errors.first(property.code) }}</span>

        </div>

      <div class="mt-5 w-full" v-for="property of propertyList" :key="property.id" v-if="property.property_type === 'date' || property.property_type === 'datetime'">

          <label class="vs-input--label">{{property.code}}</label>
          <datepicker :label="property.name" :name="property.code" class="w-full" :format="format" :value="user_property[property.code]"
                       @input="onDateChange(property.code, $event)" ></datepicker>
          <span class="text-danger text-sm" v-show="errors.has(property.code)">{{ property.code }}</span>

      </div>

        <div class="mt-5 w-full" v-for="property of propertyList" :key="property.id" v-if="property.property_type === 'integer'">

          <label class="vs-input--label">{{property.code}}</label>
          <input :ref="property.code" :label="property.name" :value="user_property[property.code]" @input="onDataChange(property.code, $event)"
                    class="w-full vs-inputx vs-input--input normal hasValue" :name="property.code" v-validate="'required'" />
          <span class="text-danger text-sm" v-show="errors.has(property.code)">{{ property.code }}</span>

        </div>

        <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">I accept the terms & conditions.</vs-checkbox>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import Places from '../../../components/google-places/Places'
import Reviews from '../../../components/google-places/Reviews'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Reviews,
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    Places
  },
  data () {
    return {
      id: null,
      name: '',
      last_name: '',
      email: '',
      phone: '',
      dataImg: null,
      uploadImg: null,
      user_group:1,
      photo: '',
      propertyList: [],
      format: 'yyyy-MM-dd',
      password: '',
      confirm_password: '',
      isTermsConditionAccepted: true,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  mounted () {
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return

      if (this.data.add === true && !this.data.duplicating) {
        this.initValues()
        this.$validator.reset()
        this.dataImg = require('@/assets/images/pages/register/upload_image.png')
      } else {
        const { name, id, last_name, phone, email, user_group, propertyList, photoUrl, photo, user_property} = JSON.parse(JSON.stringify(this.data))
        this.id = id
        this.name = name
        this.last_name = last_name
        this.phone = phone
        this.email = email
        this.user_group = user_group
        this.dataImg = (photoUrl !== null) ? photoUrl : require('@/assets/images/pages/register/upload_image.png')
        this.photo = photo
        this.propertyList = propertyList
        this.user_property = user_property

      }
      this.fixTypeOptions()
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    user_property: {
      get () {
        return this.$store.state.api.propertylist
      },
      set (val) {
        if (val) {
          this.$store.dispatch('api/setPropertyListForUser', val)
        }
      }
    },
    isFormValid () {
      if (this.data.add) {
        return !this.errors.any()
      } else {
        return !this.errors.any()
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    isFieldRequired (field) {
      if (field.code === 'Restaurant-Name' || field.code === 'Address' || field.code === 'Alias' || field.code === 'tax') {
        return 'required'
      }
      return ''
    },
    changePlace () {
      this.user_property['Google-Places-ID'] = null
    },
    placesFound (value) {
      this.user_property['Google-Places-ID'] = value.place_id
    },
    onDateChange (code_in, $event) {

      const payload = { code: code_in, val: this.getFormattedDate($event)}
      this.$store.dispatch('api/setPropertyListItemForUser', payload)
    },
    onDataChange (code_in, $event) {
      const payload = { code: code_in, val: $event}
      this.$store.dispatch('api/setPropertyListItemForUser', payload)
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
        this.uploadImg = input.target.files[0]

        const img_obj = {
          restaurantId: this.id,
          file: this.uploadImg
        }

        this.$store.dispatch('api/uploadImageProfile', img_obj,  event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        }).then((response) => {
          this.$vs.notify({
            title: 'Image uploaded',
            text: response.data.message,
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.$vs.loading.close()
        }).catch(err => {
          console.error(err)
          this.$vs.notify({
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.$vs.loading.close()
        })
      }
    },
    getFormattedDate (date) {
      return moment(date).format('yyyy-MM-DD')
    },
    initValues () {
      if (this.data.id) return
      this.id = null
      this.name = ''
      this.last_name = ''
      this.email = ''
      this.user_group = this.data.user_group
      this.propertyList = this.data.propertyList
      this.phone = ''
      this.uploadImg = null

    },
    fixTypeOptions () {
      const list = {}
      const up = this.user_property
      this.propertyList.forEach(function (item) {
        if (typeof up[item.code] === 'undefined') up[item.code] = null
        list[item.code] = up[item.code]
      })
      this.user_property = list
    },
    createHours (id, callback) {

      const dataPickup = {
        'hourType':2,
        'restaurant_id':id,
        'hours':[
          {
            'dayId':1,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':2,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':3,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':4,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':5,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':6,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':7,
            'opening':'09:00',
            'closing':'20:00'
          }
        ]
      }

      const dataDelivery = {
        'hourType':1,
        'restaurant_id':id,
        'hours':[
          {
            'dayId':1,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':2,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':3,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':4,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':5,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':6,
            'opening':'09:00',
            'closing':'20:00'
          },
          {
            'dayId':7,
            'opening':'09:00',
            'closing':'20:00'
          }
        ]
      }

      this.$store.dispatch('api/saveWeeklyHours', dataPickup).then(() => {
        this.$store.dispatch('api/saveWeeklyHours', dataDelivery).then(() => {
          callback()
        }).catch(err => {
          callback(err.message)
        })
      }).catch(err => {
        callback(err.message)
      })

    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          const payload = {
            user_id: this.id,
            email: this.email,
            name: this.name,
            last_name: this.last_name,
            user_group: this.user_group,
            property: this.user_property,
            phone: this.phone,
            active: 1
          }

          if (this.data.add) {
            delete payload.id
            payload['password'] = this.password
            payload['confirmPassword'] = this.confirm_password

            if (this.photo) {
              payload.photo = this.photo
            }

            this.$store.dispatch('api/registerUser', payload).then((response) => {
              this.$vs.notify({
                title: 'Success',
                text: response.data.message,
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })

              if (this.data.duplicating) {
                const copy_restaurant_id = response.data.data.id
                const duplicate_data = {
                  copyRestaurant: copy_restaurant_id,
                  restaurantId: this.data.duplicating_id
                }
                this.$store.dispatch('api/duplicateUser', duplicate_data).then((response) => {

                  this.createHours(copy_restaurant_id, (err) => {
                    if (err) {
                      this.$vs.loading.close()
                      this.$vs.notify({
                        title: 'Error',
                        text: err,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                      })
                      return
                    }

                    this.$vs.notify({
                      title: 'Success',
                      text: response.data.message,
                      iconPack: 'feather',
                      icon: 'icon-check',
                      color: 'success'
                    })
                    this.$emit('closeSidebar')
                    this.initValues()
                    this.$vs.loading.close()
                  })
                }).catch(err => {
                  console.error(err.message)
                  this.$vs.loading.close()
                  this.$vs.notify({
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  })
                })
              } else {
                this.$emit('closeSidebar')
                this.initValues()
                this.$vs.loading.close()
              }
            }).catch(err => {
              console.error(err.message)
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })

          } else {
            this.$store.dispatch('api/updateUserJWT', payload).then((response) => {
              this.$vs.notify({
                title: 'Success',
                text: response.data.message,
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })
              this.$emit('closeSidebar')
              this.initValues()
              this.$vs.loading.close()
            }).catch(err => {
              console.error(err.message)
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
</style>
